<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Banner Ads</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container-fluid">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-10">
            <div class="isotope-wrapper">
              <div class="box_general padding_bottom">
                <form @submit.prevent="createbanner()" method="post">
                  <div class="row">
                    <div class="col-md-12 add_top_30">
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Expire Date</label>
                            <date-picker
                              v-model="expire_date"
                              :config="datepickerconfig"
                              required
                            ></date-picker>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Location</label>
                            
                            <vue-simple-suggest
                              v-model="location"
                              display-attribute="name"
                              value-attribute="url"
                              :list="getSuggestionList"
                              @select="get($event)"
                            ></vue-simple-suggest>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Pincode</label>
                            <input
                              class="form-control"
                              type="number"
                              v-model="pincode"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <label>Categories</label>
                          <select2-multiple-control
                            :options="catOptions"
                            :settings="{
                              multiple: false,
                            }"
                            @select="catSelectEvent($event)"
                          />
                        </div>
                        <div class="col-lg-6">
                          <label>Sub Categories</label>
                          <select2-multiple-control
                            :options="subCatOptions"
                            :settings="{ multiple: true }"
                            @select="subcatselectEvent($event)"
                            placeholder="-Select Categories-"
                          />
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <label>Upload Banner Photos</label>
                            <div class="form-group">
                              <div>
                                <input
                                  class="form-control"
                                  ref="file"
                                  multiple
                                  type="file"
                                  @change="onGalleryChange"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div
                              class="col-md-2"
                              v-for="galleryimages in galleryimage"
                              :key="galleryimages.id"
                            >
                              <img
                                v-if="galleryimages.type == 'image'"
                                :src="`https://peekzy.in/backend/public/assets/user/vendorgallery/${galleryimages.link}`"
                                style="width: 100%"
                                class="mt-1"
                              />
                              <a
                                href="javascript:void(0);"
                                class="ml-3"
                                @click="
                                  removeImage(
                                    galleryimages.id,
                                    galleryimages.link
                                  )
                                "
                                ><i class="fa fa-trash"></i
                              ></a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /row-->

                      <!-- /row-->
                      <div class="row">
                        <div class="col-md-12">
                          <alert
                            transition="slide-y-transition"
                            v-if="msg"
                            :msg="msg"
                            :classAlert="classAlert"
                          ></alert>

                          <div id="pass-info" class="clearfix"></div>
                          <center>
                            <button
                              type="submit"
                              class="btn_1 rounded add_top_30 mb-3"
                            >
                              Submit
                            </button>
                          </center>
                        </div>
                      </div>
                      <!-- /row-->
                    </div>
                  </div>
                </form>
              </div>
              <!-- /row -->
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
// import axios from 'axios'
import Alert from "@/cmps/Alert";
import API from "@/services/index";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import moment from "moment";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";

export default {
  data() {
    return {
      roleId: localStorage.getItem("role_id"),
      token: "Bearer " + localStorage.getItem("token"),
      msg: null,
      expire_date: this.frontEndDateFormat(
        new Date(new Date().setDate(new Date().getDate() + 9))
      ),
      classAlert: null,
      profileDetails: [],
      catOptions: [],
      subCatOptions: [],
      location: "",
      pincode: "",
      searchcat: {
        categories: [],
        subcategories: [],
      },
      datepickerconfig: {
        format: "DD/MM/YYYY",
        useCurrent: false,
        minDate: new Date().setDate(new Date().getDate() + 7),
      },
      galleryimage: [],
      login_id: null,
      files: [],
      geocodes:[]
    };
  },
  components: {
    Frontendlayout,
    Sidebar,
    Alert,
    VueSimpleSuggest,
  },
  beforeMount() {
    this.checkToken();
    this.getParentCategories();
  },

  methods: {
    checkToken() {
      //alert(this.token);
      if (this.token == "Bearer " + null) {
        this.$router.push("/signin");
      }
    },
    get(value) {
      var i = [];
      API.get(`https://location.securebrandtech.com/auto/api?q=${value}`)
        .then(function (response) {
         var j =0 ;
          response.data.features.forEach(function (feature) {
            if(j === 0){
            i.push(feature.geometry.coordinates);
            }
           j++;
          });
        })
        .catch(function (error) {
          console.log(error);
        });
      setTimeout(() => {
        this.geocodes = i;
      }, 2000);
    }, 
    getSuggestionList() {
      var i = [];
      if (this.location.length >= 2) {
        return API.get(`https://location.securebrandtech.com/auto/api?q=${this.location}`)
          .then(function (response) {
            response.data.features.forEach(function (feature) {
              i.push(
                feature.properties.name +
                  " " +
                  feature.properties.county +
                  " " +
                  " " +
                  feature.properties.state +
                  " " +
                  feature.properties.postcode
              );
            });
            var uniq = [...new Set(i)];
            return uniq;
          })

          .catch(function (error) {
            console.log(error);
          });
      }
    },
    getParentCategories() {
      API.get("categories/parent_services_select2list")
        //.get("categories/parent_services")
        .then((res) => {
          this.catOptions = res.data.data;
          // this.search = this.search.categories;
          console.log(res.data.data);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    setSubCategory(categoryId, mode) {
      //alert(categoryId);
      // let selSubCat = this.search.subcategories;
      API.get(
        "categories/parent_services_select2list/" + window.btoa(categoryId)
      )
        //.get("categories/parent_services")
        .then((res) => {
          if (mode == "push") {
            res.data.data.forEach((val) => {
              console.log("val=" + JSON.stringify(val));
              this.subCatOptions.push(val);
              //this.subCatOptions.concat(res.data.data);
            });

            //console.log("sub cat options=" + this.subCatOptions);
          } else {
            //this.search.subcategories.push(res.data.data);
            res.data.data.forEach((val) => {
              this.subCatOptions.splice(this.subCatOptions.indexOf(val.id), 1);
            });
          }
          this.searchcat.subcategories = [];
          // this.emitFilterRequest();
          //this.loadNearbyOffers(this.search);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    catSelectEvent(e) {
      var sel = e.selected;
      if (sel) {
        this.setSubCategory(e.id, "push");
        this.searchcat.categories.push(e.id);
      } else {
        this.setSubCategory(e.id, "remove");
        this.searchcat.categories.splice(
          this.searchcat.categories.indexOf(e.id),
          1
        );
      }
    },
    subcatselectEvent(e) {
      var sel = e.selected;
      //alert(sel + " " + e.id + " " + e.text + " " + e.selected);
      if (sel) {
        this.searchcat.subcategories.push(e.id);
      } else {
        this.searchcat.subcategories.splice(
          this.searchcat.subcategories.indexOf(e.id),
          1
        );
      }
      //this.loadNearbyOffers(this.search);
    },
    frontEndDateFormat(date) {
      //alert(moment(date, "YYYY-MM-DD").format("DD-MM-YYYY"));
      return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
    },
    backEndDateFormat: function (date) {
      return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    },

    createbanner() {
       const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
       if(this.geocodes.length == 0){
         Toast.fire({
          icon: "Error",
          title: "Please Select Location List Option ",
        });
        this.loading = false;
        return false;
      }
      const form = new FormData();
      form.append("expiredate", this.backEndDateFormat(this.expire_date));
      form.append("serviceprice", "banner");

      API.post("/Banner/getserviceprice", form, {
        headers: { Authorization: this.token },
      }).then((res) => {
        this.$swal({
          title: "Are you sure!",
          text: res.data,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes proceed to banner ads",
          closeOnConfirm: false,
        }).then((isConfirm) => {
          if (!isConfirm.isConfirmed) {
            this.$router.push("/banner-ads/");
            return false;
          } else {
       
            const form = new FormData();
            form.append("role_id", this.roleId);
            form.append("expiredate", this.expire_date);
            form.append("location", this.location);
            form.append("category", JSON.stringify(this.searchcat));
            form.append("pincode", this.pincode);
            form.append("lat", this.geocodes);
            if (this.files != null) {
              for (let i = 0; i < this.files.length; i++) {
                form.append("image[]", this.files[i]);
              }
            }
            API.post("/Banner/createbanner", form, {
              headers: { Authorization: this.token },
            })
              .then((res) => {
                if (res.data.status == 200) {
                  this.msg = "Your Banner Added Successfully";
                  setTimeout(() => {
                    this.msg = "";
                  }, 3000);
                  this.classAlert = "success";
                  this.$router.push("/banner-list");
                } else {
                  this.msg = res.data.messages;
                  this.classAlert = "danger";
                }
              })
              .catch((err) => {
                this.msg = err.response.data.messages.error;
                setTimeout(() => {
                  this.msg = "";
                }, 3000);
                this.classAlert = "danger";
              });
          }
        });
      });

      //axios
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.profile_img = files[0];
    },
    onGalleryChange() {
      this.files = this.$refs.file.files;
    },
    createImage(file) {
      this.image = new Image();
      var reader = new FileReader();

      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>
<style  scoped>
@import "../../public/frontend/vendor/dropzone.css";

.show_img,
.header_box img {
  width: 100%;
}
</style>